<template>
    <b-container fluid class="desconectar-reset-container">
        <div>
                <a>
                    <div>
                        <img alt="Logo Finanças 360" :src="require('@/assets/logo.png')">
                    </div>
                </a>
                <h2> Acesso em andamento </h2>
                <p>
                    Identificamos que existe outro acesso em andamento. 
                </p>    
                <p class="desconectar-reset-container-info">
                    Se você continuar você irá encerrar o acesso do outro usuário.
                    Gostaria de continuar o login? 
                </p>
      
                <b-button block variant="primary" @click="handleDesconectUser">Continuar</b-button>
                <b-link block href="/">voltar</b-link>
            </div>
    </b-container>
</template>
<script>
export default {
  name: 'F360FranqueadorFrontendDesconectar',
  data () {
    return {
        temporaryToken:{
            TemporaryToken:"",
            IsForced:"",
            LoginToken:"",
            IsOnline:false,
        }
    };
  },
  created(){
      const tempToken = localStorage.getItem("tokenTemp");
      const forcedLogin = localStorage.getItem("forcedLogin");
      const tokenLogin = localStorage.getItem("loginToken")
      const isOnline = localStorage.getItem("isOnline");

        if(tempToken && forcedLogin && tokenLogin && isOnline){
            this.temporaryToken.TemporaryToken = tempToken;
            this.temporaryToken.IsForced = forcedLogin;
            this.temporaryToken.LoginToken = tokenLogin;
            this.temporaryToken.IsOnline = isOnline;
        }else{
            this.$router.push({ path: '/', name: 'public' });
        }
  },

  mounted () {
  },
  methods: {
    async handleDesconectUser(){

        // localStorage.removeItem('accessToken')

        // let loadingInstance = Loading.service(Loading);

        await this.axios.post(this.$urls.DELETE_TOKEN,this.temporaryToken).then((resDelete) => {

            if(resDelete.status == 200){

                //Login antigo que precisa ser derrubado...
              
                localStorage.clear()
                this.axios.post(this.$urls.LOGIN,resDelete.data.user).then((res) => { // request OK
                    // loadingInstance.close()
                    this.trackingF360(this, 'Logout', 'Dimensões personalizadas');

                    if(res.status == 200){
                        localStorage.setItem('user',JSON.stringify({ customer: res.data.customer, user: res.data.user }))
                        localStorage.setItem('accessToken',res.data.accessToken)
                        localStorage.setItem('loginToken',res.data.loginToken)
                        localStorage.setItem('isOnline',res.data.isOnline)
                        this.$router.push({ path: '/', name: 'secure' })

                        var getUser = JSON.parse(localStorage.getItem('user')) || ''

                        this.user = res.data.user;

                        this.$notify({
                            title: 'Seja Bem vindo !',
                            message: `${getUser.user.nome} 😃`,
                            position: 'bottom-right',
                            customClass: 'bg-dark'
                        });
                    }
                })
                // router.push({ path: '/', name: 'secure' })
            }
        }).catch(function(){
            // loadingInstance.close();
        })
        return false;
    }
  },
  computed: {
		user: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('updateUser', value);
            }
        }
	},
};
</script>

<style lang="scss" scoped>

.desconectar-reset-container{
    position: absolute;
    max-width: 500px;
    left: -20%;
    right: 0;
    top: 100px;
    bottom: 0;
}

.desconectar-reset-container div{
 display: flex;
    background: white;
    text-align: center;
    border-radius: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    img{
        width: 200px;
    }
}
.btn-container{
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;
}
.desconectar-reset-container-info{
    color: #dd5555;
    font-weight: bold;
}

@media (max-width: 600px){
  .desconectar-reset-container{
    left: 0%;
}

}
</style>